

    import React,{Component} from 'react';
	
	 //import {BrowserRouter,Route,Link} from 'react-router-dom';
	 import axios from "axios";
    //import { triggerAsyncId } from 'async_hooks';

	
	 
	class verifyEmailComponent extends Component{
	
		constructor(props)
		{
			super(props)
			
			this.state = {
				verificationToken: null
			}

            this.componentDidMount = this.componentDidMount.bind(this);
		}
	
        
        
       async componentDidMount()
        {
              //make verification api call
              let tokenParam = this.props.match.params.token;

                
                
                this.setState({verificationToken: tokenParam});


                if(this.props.match.params.token != null)
                {
                    //make api call
                    
                    try{
                        let response  =  await axios.get(`http://mofehintolumumuni.com/gitserver/api/users/email/verification/${tokenParam}`);
    
                        let status = response.data.status;
                        let VerifyStatus = response.data.VerifyStatus;
    
                        if(status === "success")
                        {
                            alert(`${VerifyStatus} . A confirmation email has been sent to your mail.`);
                            this.props.history.push("/gitsearch/");
                        }else
                        {
                            alert(VerifyStatus);
                            this.props.history.push("/gitsearch/");
                        }
            
                    }
                    catch(error)
                    {
                        alert(`Email verification not successful`);
                        this.props.history.push("/gitsearch/");
                       
                    }
                }
                else
                {
                    alert("Invalid token");
                   this.props.history.push("/gitsearch/");
                }

        }

       async componentDidUpdate()
        {
           
        }

        
    


	render()
	{
	return(
	
		<React.Fragment>
		<section>
		<div id="page-wrapper" className="sign-in-wrapper">
				<div className="graphs">
					<div className="sign-in-form">
						<div className="sign-in-form-top">
							<h1>EMAIL VERIFICATION!  <i className="fa fa-cogs"></i></h1>
						</div>
					
					</div>
				</div>
			</div>
			</section>
</React.Fragment>

	);
	}


    }
    



    export default verifyEmailComponent;


